/*
 * File: ContactUs.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: List of contact methods
 */
import React from "react";
import UITextHeader from "components/ui/UITextHeader";
import UIPhoneLink from "components/ui/UIPhoneLink";
import UIListItem from "components/ui/UIListItem";
import { List } from "@material-ui/core";

const addressGroup = {
  label: "Address",
  value: "233 N. 8th Street, Suite 300 - Lincoln, NE"
};

const ContactUs = () => (
  <React.Fragment>
    <UITextHeader title="Contact Us" />
    <List>
      <UIListItem
        label="Main Line"
        value={<UIPhoneLink phone="(402) 420-2430" />}
      />
      <UIListItem
        label="Support (US)"
        value={<UIPhoneLink phone="(877) 220-8418" />}
      />
      <UIListItem
        label="Support (International)"
        value={<UIPhoneLink phone="0011-800-2525-9898" />}
      />
      <UIListItem
        label="Website"
        value={<a href="https://www.macpractice.com">www.macpractice.com</a>}
      />
      <UIListItem labelGroup={addressGroup} />
    </List>
  </React.Fragment>
);

export default ContactUs;
